import { FunctionComponent } from 'react';
import { useAiAgentTalkUrl } from 'hooks/useAiAgent';
import styles from './AiAgentFrame.module.scss';

const IFRAME_ALLOW = 'microphone *; camera *; autoplay *; clipboard-write *';

const AiAgentFrame: FunctionComponent = () => {
    const talkUrl = useAiAgentTalkUrl();

    return (
        <iframe
            title="AI Agent"
            src={talkUrl}
            className={styles.iframe}
            allow={IFRAME_ALLOW}
            referrerPolicy="origin"
        />
    );
};

export default AiAgentFrame;
